import { http } from "@/http";

const PATH = "app/reports/visits";

function getCustomerHeaders() {
  return {
    headers: {
      customer: localStorage.getItem("__uuid"),
      __company: localStorage.getItem("__company"),
    },
  };
}

class ReportsService {
  async getAll(params = {}) {
    return http.get(PATH, { params });
  }

  async getById(id) {
    return http.get(PATH.concat("/").concat(id));
  }

  async create(payload) {
    return http.post(PATH, payload, getCustomerHeaders());
  }

  async update(id, payload) {
    return http.post(
      PATH.concat("/").concat(id).concat("/edit"),
      payload,
      getCustomerHeaders()
    );
  }

  async finish(id) {
    return http.patch(
      PATH.concat("/").concat(id).concat("/finish"),
      null,
      getCustomerHeaders()
    );
  }

  async archive(id) {
    return http.patch(
      PATH.concat("/").concat(id).concat("/archive"),
      null,
      getCustomerHeaders()
    );
  }

  async restore(id) {
    return http.patch(
      PATH.concat("/").concat(id).concat("/restore"),
      null,
      getCustomerHeaders()
    );
  }

  async reopen(id) {
    return http.patch(
      PATH.concat("/").concat(id).concat("/reopen"),
      null,
      getCustomerHeaders()
    );
  }

  async generatePdf(id) {
    return http.post(
      PATH.concat("/").concat(id).concat("/generate-pdf"),
      null,
      getCustomerHeaders()
    );
  }

  async clone(id) {
    return http.post(
      PATH.concat("/").concat(id).concat("/clone"),
      null,
      getCustomerHeaders()
    );
  }
}

export default new ReportsService();
export { PATH };
